export default "__VITE_ASSET__72f8f08e__"